import React from 'react';
import withSelections from '../withSelections';
import Theme from '../../Theme';
import StyledAddon from './styles';
import CheckIcon from '../../SVG/CheckIcon';

const AddOn = ({
  title,
  description,
  id,
  isDisabled,
  isAdded,
  handleClick,
  badgeCopy,
  rate,
}) => {
  const { colorWhite } = Theme.color;
  const { scaleDown03 } = Theme.scale;

  return (
    <StyledAddon
      className={`addon-${id} ${isAdded ? 'is-selected' : ''} ${
        isDisabled ? 'is-disabled' : ''
      }`}
      data-testid={`addon-${id}`}
    >
      <h3 className="m-bottom-0">
        {title}
        {isDisabled && <span className="tag tag--orange">{badgeCopy}</span>}
      </h3>
      <div className="addon-content">
        <p className="is-size-14 m-bottom-0">{description}</p>
        <p className="addon-price is-h3 m-right-5 m-bottom-0 m-left-5">{`$${rate}.00/mo*`}</p>
        <button
          type="button"
          className={`btn ${isAdded ? 'btn--secondary' : 'btn--primary'}`}
          onClick={handleClick}
          disabled={isDisabled}
          data-testid={`addon-btn-${id}`}
        >
          {isAdded ? 'Remove' : 'Add'}
        </button>
      </div>
      <div className="icon-wrapper">
        <CheckIcon size={scaleDown03} color={colorWhite} />
      </div>
    </StyledAddon>
  );
};
export default withSelections(AddOn);
